
import { OAuthService, AuthConfig, JwksValidationHandler, NullValidationHandler, LoginOptions } from 'angular-oauth2-oidc';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { UserExtensions } from './user-extensions';
import { UserProfile } from '../api/resources/user-resources';
import { RouterStateSnapshot, Router } from '@angular/router';

export function AppAuthConfig(): AuthConfig {
  return {
    issuer: environment.endpoints.authority,
    redirectUri: window.location.origin + '/index.html',
    silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
    clientId: environment.authentication.appId,
    dummyClientSecret: environment.authentication.appSecret,
    responseType: 'code',
    scope: environment.authentication.scopes,
    showDebugInformation: environment.authentication.showDebug,
    sessionChecksEnabled: environment.authentication.enableSessionChecks,
    requireHttps: environment.authentication.requireHttps,
    silentRefreshShowIFrame: environment.authentication.silentRefreshShowIFrame,
    oidc: true
  };
}

export class AuthenticationExt {

  public static Configure(auth: OAuthService) {

    const cfg = AppAuthConfig();
    auth.configure(cfg);
    auth.setupAutomaticSilentRefresh();
    auth.setStorage(sessionStorage);
    return {
      initialize: () => AuthenticationExt.initialize(auth),
      // enableAutoTokenRefresh: () => AuthenticationExt.configureTokenRefresh(auth),
      populateUser: () => AuthenticationExt.populateUser(auth),
    };
  }

  private static initialize(auth: OAuthService): Observable<boolean> {

    return new Observable<boolean>((observer) => {

      auth.loadDiscoveryDocumentAndTryLogin().then(_ => {
        if (!auth.hasValidIdToken() || !auth.hasValidAccessToken()) {
          const path = window.location.pathname;
          auth.initCodeFlow(path);
        } else {
          observer.next(true);
          observer.complete();
        }
      });
    });
  }

  private static populateUser(auth: OAuthService): Observable<UserProfile> {

    return new Observable<UserProfile>((observer) => {
      auth.loadUserProfile().then(data => {
        observer.next(UserExtensions.parseClaims(data));
        observer.complete();
      });
    });
  }
}
